import { logWrapper } from '../../utils';

export default {
  supportService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    function (runtimeConstant, $http, $q, $filter, webApiSettings) {
      'use strict';

      function handleError(err) {
        return {
          statusCode: err.status,
          title: $filter('translate')('SERVER OFFLINE'),
          text: $filter('translate')('SERVER OFFLINE MESSAGE'),
        };
      }

      function openNewSupportTicket(body) {
        var deferred = $q.defer();

        var nameAndAddress = [];
        nameAndAddress.push({
          key: 'Suporte',
          value: 'suporte@digitaldoc.com.br',
        });

        $http
          .post(webApiSettings.apiServiceBaseUri + 'support/newticket', {
            Subject: null,
            NameAndAddress: nameAndAddress,
            Body: body,
            IsBodyHtml: true,
          })
          .then(() => {
            deferred.resolve();
          })
          .catch((err, status, headers, config) => {
            var error = handleError(
              {
                err: err,
                status: status,
                headers: headers,
                config: config,
                data: {},
              },
              false,
              true
            );
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function run() {
        try {
          var supportServiceFactory = {};

          supportServiceFactory.openNewSupportTicket = logWrapper(
            openNewSupportTicket,
            runtimeConstant.isDebugServicesInternals
          );

          return supportServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
